import { useState, useEffect, useCallback } from 'react';
import { useApi } from './useApi';

export const useProducts = () => {
  const [products, setProducts] = useState([]);
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const { loading, error, get } = useApi();

  const fetchProducts = useCallback(async (params = {}) => {
    // Filtrar parámetros undefined para no enviarlos al backend
    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(([_, value]) => value !== undefined && value !== '')
    );
    const queryString = new URLSearchParams(filteredParams).toString();
    const endpoint = `/public/products${queryString ? `?${queryString}` : ''}`;
    
    const result = await get(endpoint);
    
    if (result.success) {
      // Backend returns { data: { products: [...], meta: {...} } }
      setProducts(result.data?.products || []);
    }
    
    return result;
  }, [get]);

  const fetchFeaturedProducts = useCallback(async () => {
    const result = await get('/public/products/featured');
    
    if (result.success) {
      setFeaturedProducts(result.data.products || result.data);
    }
    
    return result;
  }, [get]);

  const fetchProductBySlug = useCallback(async (slug) => {
    return await get(`/public/products/${slug}`);
  }, [get]);

  const fetchCategories = useCallback(async () => {
    const result = await get('/public/categories');
    
    if (result.success) {
      setCategories(result.data.categories || result.data);
    }
    
    return result;
  }, [get]);

  useEffect(() => {
    fetchCategories();
  }, [fetchCategories]);

  return {
    products,
    featuredProducts,
    categories,
    loading,
    error,
    fetchProducts,
    fetchFeaturedProducts,
    fetchProductBySlug,
    fetchCategories,
  };
};

export default useProducts;
